export default "__VITE_PUBLIC_ASSET__f62e73d3__"